// extracted by mini-css-extract-plugin
export var root = "deeT";
export var rootButton = "tb3-";
export var rootButtonWrapper = "YsNz";
export var rootContainer = "jLN1";
export var rootMobileOpened = "DuPp";
export var rootNavLabel = "z61e";
export var rootNavLabelIcon = "ii3V";
export var rootOverflowHidden = "aeX9";